
import React from 'react' 
export const HeroGreen = () => {

    return (
       <React.Fragment>
            <div className='hero green'>
                <div className="heading-two flex">
                    <div className='head flex'>
                            <h1 className='title'>
                                Get millions of downloads!
                            </h1>
                            <p className='description'>
                            Delectus corrupti asperiores, voluptas
                voluptatem alias maiores dolorum veritatis atque.
                            </p>
                    </div>
                    <div className="image">
                            <img src="/assets/images/bg/char.png" alt="" />
                    </div>

                    <img src="/assets/images/bg/world.png" className='world' alt="" />
                </div>
                
                </div>
                <div className="wave"><div className="steps"></div></div>
       </React.Fragment>

    )
}

